import { ISubmission } from 'app/shared/model/submission.model';

export interface ISubmissionRequest {
  id?: number;
  requestJson?: string | null;
  type?: string | null;
  ocrJson?: string | null;
  responseJson?: string | null;
  submission?: ISubmission | null;
}

export const defaultValue: Readonly<ISubmissionRequest> = {};
